<template>
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.6">
      <path
        d="M0 24.1094C0 18.703 0 13.2236 0 7.77333C0 7.77333 0.413249 7.77333 0.626998 7.77333C3.27749 7.77333 5.92798 7.75872 8.57847 7.80256C10.2885 7.83178 11.9272 8.25553 13.395
          9.2053C16.2592 11.0464 17.5274 14.0418 16.9432 17.461C16.4302 20.4564 13.9365 23.0866 10.887 23.7587C10.0035 23.9487 9.09147 24.0656 8.19372 24.0802C5.67148 24.124 3.14924 24.0948 0.626998
          24.0948C0.441748 24.0948 0 24.1094 0 24.1094ZM5.41498 20.1642C6.25573 20.1642 7.01098 20.1788 7.76622 20.1642C9.78972 20.1058 11.3145 18.6446 11.5425 16.5697C11.799 14.3195 10.6732 12.3468
          8.70672 11.9085C7.65222 11.6747 6.52648 11.7332 5.41498 11.6601C5.41498 14.5532 5.41498 17.3149 5.41498 20.1642Z"
        fill="white"
      />
      <path
        d="M17.7695 32C31.4495 25.2639 31.649 6.86758 18.083 0C21.3178 0.423744 24.1678 1.73881 26.6615 3.87215C29.7252 6.48767 31.5492 9.78995 31.9055 13.8959C32.2902 18.411
          31.5635 22.6046 28.514 26.126C25.6925 29.3991 22.1443 31.3279 17.7695 32Z"
        fill="white"
      />
      <path
        d="M12.9247 28.0842C23.6691 22.6486 23.7546 9.16182 12.9104 3.79927C18.2399 3.69698 25.3506 7.71525 25.3506 15.9125C25.3649 24.0805 18.4109 28.128 12.9247 28.0842Z"
        fill="white"
      />
      </g>
  </svg>
</template>
